import { env } from '@/libs/env'

export default {
  'Account Settings': 'Account Settings',
  'Agency Settings': 'Agency Settings',
  'Change Password': 'Change Password',
  'Knowledge Base': 'Knowledge Base',
  List: 'List',
  Detail: 'Detail',
  Edit: 'Edit',
  Search: 'Search',
  Results: 'Results',
  Support: 'Support',
  'Raise Support': 'Raise Support',
  Documentations: env.isInfoPortalTitleReplaceDocuments ? 'Information portal' : 'Documentations',
  Dashboards: 'Dashboards',
  eCommerce: 'eCommerce',
  Analytics: 'Analytics',
  'Apps & Pages': 'Apps & Pages',
  Invoice: 'Invoice',
  'Invoice List': 'Invoice List',
  'Invoice Additional List': 'Invoice Additional List',
  'Invoice Request List': 'Invoice Request List',
  'Invoice Create': 'Create Invoice',
  'Invoice Request Create': 'Create Invoice Request',
  'Invoice Create And Request Release': 'Create Invoice And Request Release',
  'Invoice Detail': 'Invoice Details',
  'Invoice Replace': 'Invoice Replace',
  'Invoice Adjust': 'Invoice Adjust',
  'Invoice Duplicate': 'Invoice Duplicate',
  'Invoice Preview': 'Invoice Preview',
  'Invoice Request Detail': 'Invoice Request Detail',
  'Certificate Manage': 'Certificate Manage',
  'Invoices Release Batches': 'Invoices Release Batches',
  'Release Registration': 'Release Registration',
  Declaration: 'Declaration',
  'Authorization Declaration': 'Authorization Declaration',
  'Invoice Template': 'Invoice Template',
  'Incorrect Invoices List': 'Incorrect Invoices List',
  'Incorrect Invoice Create': 'Create Incorrect Invoice',
  'Incorrect Invoice Detail': 'Incorrect Invoice Detail',
  'Incorrect Invoice Preview': 'Incorrect Invoice Preview',
  Preview: 'Preview',
  Add: 'Add',
  Details: 'Details',
  View: 'View',
  Authentication: 'Authentication',
  'Login v1': 'Login v1',
  'Login v2': 'Login v2',
  'Register v1': 'Register v1',
  'Register v2': 'Register v2',
  'Forget Password v1': 'Forget Password v1',
  'Forget Password v2': 'Forget Password v2',
  'Forgot Password v1': 'Forgot Password v1',
  'Forgot Password v2': 'Forgot Password v2',
  'Reset Password v1': 'Reset Password v1',
  'Reset Password v2': 'Reset Password v2',
  'Coming Soon': 'Coming Soon',
  'Not Authorized': 'Not Authorized',
  'Under Maintenance': 'Under Maintenance',
  Error: 'Error',
  Statistics: 'Statistics',
  Apps: 'Apps',
  'User Interface': 'User Interface',
  'Mail Templates': 'Mail Templates',
  Welcome: 'Welcome',
  'Reset Password': 'Reset Password',
  'Verify Email': 'Verify Email',
  'Deactivate Account': 'Deactivate Account',
  Promotional: 'Promotional',
  'Page Layouts': 'Page Layouts',
  'Collapsed Menu': 'Collapsed Menu',
  'Layout Boxed': 'Layout Boxed',
  'Without Menu': 'Without Menu',
  'Layout Empty': 'Layout Empty',
  'Layout Blank': 'Layout Blank',
  Case: 'Case',
  Queue: 'Queue',
  'Preview temp': 'Preview temp',
  10: '10',

  Booking: 'Booking',
  Bookings: 'Bookings',
  Reservations: 'Reservations',
  'Reservation Detail': 'Reservation Detail',
  'Reservation Ticket': 'Reservation Ticket',
  HOLD: 'HOLD',
  PAID: 'PAID',
  CANCEL: 'CANCEL',
  EXPIRED: 'EXPIRED',
  Customer: 'Customer',
  Employee: 'Employee',
  Agency: 'Agency',
  Contract: 'Contract',
  Receipt: 'Receipt',
  Receipts: 'Receipts',
  Document: 'Document',
  Account: 'Account',
  Documents: 'Documents',

  'Create New Employee': 'Create New Employee',
  'Employee management': 'Employee management',
  'Create New': 'Create New',
  'Employee detail': 'Employee detail',
  'Employee List': 'Employee List',
  'Create New Customer': 'Create New Customer',
  'Customer management': 'Customer management',
  'Customer detail': 'Customer detail',
  'Customer List': 'Customer List',
  'Contact Add': 'Contact Add',
  Contacts: 'Contacts',
  'Contact Edit': 'Contact Edit',
  'Create New Agency': 'Create New Agency',
  'Agency Management': 'Agency Management',
  'Agency Detail': 'Agency Detail',
  'Agency List': 'Agency List',
  'Create New Receipt': 'Create New Receipt',
  'Receipt Management': 'Receipt Management',
  'Receipt Detail': 'Receipt Detail',
  'Receipt List': 'Receipt List',
  Flight: 'Flight',
  'Flight v2': 'Flight',
  general: 'General',
  changePassword: 'Change Pasword',
  'Search flights': 'Search flights',
  Tickets: 'Tickets',
  'Error Notification': 'Error Notification',
  'Accounts payable general': 'Accounts payable',
  'Accounts payable': 'Accounts payable',
  'Account Payable Retail': 'Account Payable Retail',
  'Accounts payable list': 'Accounts payable list',
  'Detail accounts payable': 'Detail accounts payable',
  'Update accounts payable': 'Update accounts payable',
  'Import accounts payable': 'Import Excel',
  'Sale Report': 'Sale Report',
  'Sale Report Retail': 'Sale Report Retail',
  'Sale Report Refund Ticket': 'Refund entitled to pax',
  Role: 'Role',

  // ANCHOR: configs
  Settings: 'Settings',
  'My account': 'My account',
  'Agency account': 'Agency account',
  Configs: 'Configs',
  'Fee Configs': 'Agency fee config',
  'Service Fee Configs': 'Customer fee config',
  electronicTicket: 'E-Ticket config',
  electronicTicketTrain: 'E-Ticket Train config',
  configsDisplay: 'Display Configs',
  systemConfigs: 'System Configs',
  'Send Notification': 'Send Notification',
  // ANCHOR: Sale Report
  'Create sale report manually': 'Create sale report manually',
  'Sale report detail': 'Sale report detail',

  Promotion: 'Promotion',
  // ANCHOR: Promotion AG
  'Promotion AG': 'Promotion AG',
  'Promotion AG List': 'Promotion AG List',
  'Create New Promotion AG': 'Create New Promotion AG',
  'Promotion AG detail': 'Promotion AG detail',

  // ANCHOR Promotion Airline
  'Promotion Airline': 'Promotion Airline',
  'Promotion Airline List': 'Promotion Airline List',
  'Create New Promotion Airline': 'Create New Promotion Airline',
  'Promotion Airline Detail': 'Promotion Airline Detail',

  // ANCHOR: Promotion User
  'Promotion User': 'Promotion User',
  'Promotion User List': 'Promotion User List',
  'Create New Promotion User': 'Create New Promotion User',
  'Promotion User Detail': 'Promotion User Detail',

  // ANCHOR: Work Schedule
  'Work Schedule': 'Work Schedule',
  'Work Schedule List': 'Work Schedule List',
  'Create Work Schedule': 'Create Work Schedule',

  // ANCHOR: Airlines 1G can pay
  'Airlines 1G can pay': 'List of airlines issuing BSP tickets',

  // ANCHOR Document Management cong van tai lieu
  'Document Management': 'Document Management',
  'Folder list': 'Folder list',
  'Document list': 'Document list',
  'Create New Document': 'Create New Document',
  'Document Detail': 'Document Detail',

  // ANCHOR: Flight Preparation list
  'Flight Preparation': 'Flight Preparation',
  'Flight Preparation List': 'Flight Preparation List',

  // ANCHOR Agency Balance
  'Agency Balance': 'Agency Balance',

  // ANCHOR find booking VJ
  'Find Booking Vietjet': 'Find Booking Vietjet',
  // ANCHOR retail
  Retail: 'Retail',
  'Retail Report': 'Retail Report',
  'Retail Bookings': 'Retail Bookings',
  'Retail Config Service Fee': 'Retail Config Service Fee',

  // ANCHOR booking statistic
  'Booking Statistic': 'Hold Booking Statistic',
  'Low Fare Tracking Statistic': 'Low fare Tracking Statistic',
  'Past Day Booking List': 'Past Day Booking List',
  Terminals: 'Terminals',

  'Reference Data Search': 'Reference Data Search',
  Utils: 'Utils',
  'Agency package configs': 'Agency package configs',
  'Agency package history': 'History of Agency package',
  'Agency package order': 'Agency package order',
  'Package configs': 'Package Websites/API/Retail configs',
  'Package websites/API configs': 'Package websites/API configs',
  'Package configs create': 'Create package configs',
  'Package configs detail': 'Package configs detail',
  'Package Coupons': 'Package Coupons',
  'Check-in cancellation VNA': 'Check-in cancellation VNA',
  'Check-in cancellation Bamboo': 'Check-in cancellation Bamboo',
  'Entry declaration Thailand': 'Thailand entry declaration form',
  Thailand: 'Thailand',
  'Entry declaration': 'Entry declaration',
  'Entry declaration Singapore': 'Singapore entry declaration form',
  titleRepicient: 'Topup request',
  titleSender: 'Topup',
  officialDispatch: 'Official Dispatch',
  sepayManager: 'Sepay Manager',
  'Bank accounts': 'Bank accounts',
  Transactions: 'Transactions',
  Companies: 'Companies',
  'Resell Ticket': 'Resell Ticket',
  'Search resell Ticket': 'Resell ticket list',
  'Manager Resell Ticket': 'Manager Resell Ticket',
  suggestShopVJ: 'Suggest marketplace',
  'Support Request': 'Support Request',
  Banks: 'Banks',
  Train: 'Train',
  'Train Search Fares': 'Train Search Fares',
  'Train Ticket Search': 'Train Ticket Search',
  'Train Ticket List': 'Train Ticket List',
  'Train Ticket Detail': 'Train Ticket Detail',
  'Train Search': 'Train Search',
  'Invoice Tickets': 'Invoice Tickets',
  'Invoice Ticket List': 'Invoice Ticket List',
  'Invoice Ticket Create': 'Invoice Ticket Create',
  flightCalendar: 'Flight Calendar',
  'Tour List': 'Tours',
  'Tour Detail': 'Tour Detail',
  'Tour Booking List': 'Tour Booking List',
  'Tour Booking Detail': 'Tour Booking Detail',
  'Book Tour': 'Book Tour',
  'Message Board': 'Message Board',
  'Find Booking By PNR - VN1A': 'Find Booking by PNR - VN1A',
  'Find Booking By PNR - VN1A_MT': 'Find Booking by PNR - VN1A_MT',
  'Find Booking By PNR - VJ': 'Find Booking by PNR - VJ',
  'Find Booking By PNR - VU': 'Find Booking by PNR - VU',
  'Find Booking By PNR - QH': 'Find Booking by PNR - QH',
  'Find Booking By PNR - 1G': 'Find Booking by PNR - 1G',
  'Find Booking By PNR - Other': 'Find Booking by PNR - Khác',
  'Agent Request Stats': 'Agent Request Stats',
  'Instructions for use': 'Instructions for use',
  'Check-in online': 'Cancel/Check-in online',
  'Flights Schedule': 'Flights Schedule',
}
